const LeadAnalyticsSkeleton = () => (
  <>
    <div className="skeleton-section-card" style={{ marginBottom: 20 }}>
      <div className="skeleton" style={{ height: 20, width: 160, marginBottom: 16 }} />
      <div className="kpi-grid" style={{ marginBottom: 16 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skeleton-card">
            <div className="skeleton" style={{ height: 14, width: '60%', marginBottom: 8 }} />
            <div className="skeleton" style={{ height: 28, width: '50%' }} />
          </div>
        ))}
      </div>
    </div>

    <div className="analytics-grid">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="skeleton-section-card">
          <div className="skeleton" style={{ height: 20, width: 140, marginBottom: 16 }} />
          <div className="skeleton skeleton-chart" />
        </div>
      ))}
    </div>
  </>
);

export default LeadAnalyticsSkeleton;
